import { makeStyles } from '@material-ui/core';

export const useMenuStyles = makeStyles({
  select: {
    boxShadow: 'none',
    border: '1px solid #cbcbcb',
    borderRadius: 5,
  },
});
